export const INCREASE_LOADING_COUNT_STATE = 'increaseLoadingCountState'
export const DECREASE_LOADING_COUNT_STATE = 'decreaseLoadingCountState'
